/** Empty controlled selection for MUI X DataGrid v8+. An array is treated as exclude-all and crashes. */
export const emptyRowSelectionModel = () => ({ type: 'include', ids: new Set() });

/** Controlled `rowSelectionModel` from a list of ids. */
export const toIncludeSelectionModel = (ids = []) => ({
  type: 'include',
  ids: new Set(Array.isArray(ids) ? ids : []),
});

/**
 * MUI X DataGrid v8+ passes `{ type, ids: Set }`; older code used a plain id array.
 * `type: 'exclude'` means every row except `ids` is selected (header select-all).
 */
export const rowSelectionIds = (model, allRowIds = []) => {
  if (model == null) return [];
  if (Array.isArray(model)) return [...model];
  if (typeof model === 'object' && model.ids != null) {
    const listed = Array.from(model.ids);
    if (model.type === 'exclude') {
      const excluded = new Set(listed.map(String));
      return allRowIds.filter(id => !excluded.has(String(id)));
    }
    return listed;
  }
  return [];
};

/**
 * Ids for a server-paginated checkbox grid.
 * Header select-all emits `{ type: 'exclude' }` unless
 * `disableRowSelectionExcludeModel` is set. An empty exclude set means every
 * loaded row, and ids chosen on other pages stay selected.
 */
export const mergePageSelectionIds = (model, pageIds = [], previouslySelected = []) => {
  const page = pageIds.map(String);
  if (model?.type === 'exclude' && model.ids != null) {
    const excluded = new Set(Array.from(model.ids).map(String));
    const pageSet = new Set(page);
    const onPage = page.filter(id => !excluded.has(id));
    const offPage = previouslySelected.map(String).filter(id => !pageSet.has(id));
    return [...offPage, ...onPage];
  }
  return rowSelectionIds(model, page).map(String);
};
